import React, { useRef, useState, useEffect, useContext, useCallback, useMemo} from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { SplitButton } from 'primereact/splitbutton';
import { Fieldset } from 'primereact/fieldset';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from "primereact/checkbox";
import { Menu } from 'primereact/menu';
import axios from "axios";

import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";

import { BarrioContext } from "../components/BarrioContext"; // ruta a tu provider
import { useAuth } from "../components/AuthContext";
import { useTerminologia } from "../hooks/useTerminologia";

import LoadingOverlay from '../components/LoadingOverlay';


import { Toast } from 'primereact/toast';
import { confirmPopup } from 'primereact/confirmpopup';

const GastoUnidadFuncional = () => {
    const initialFormData = {
      gastoUFId: null,
      unidadFuncionalId: null,
      configuractionTipoGastoId: null,
      importe: "",
      aplica: false,
      periodo: null,
      observaciones: "",
    };
    const toast = useRef(null);
    const [campos, setCampos] = useState([]);
    //const [formData, setFormData] = useState({});
    const [formData, setFormData] = useState(initialFormData);
    const [opciones, setOpciones] = useState({}); // almacena combos dinÃ¡micos
    const [editingId, setEditingId] = useState(null); // null = nuevo, != null = edita
    

    const { barrio } = useContext(BarrioContext);
    const { administracionId } = useAuth();
    const t = useTerminologia();

    const [visible, setVisible] = useState(false);
    const [unidadesFuncionales, setUnidadesFuncionales] = useState([]);

    useEffect(() => {
        if (!barrio?.id) return;
        axios.get(`${HOST_API}api/unidadesFuncionales/getUnidadesFuncionales?unidadFuncionalId=0&administracionId=${administracionId}&barrioId=${barrio.id}`)
            .then(res => setUnidadesFuncionales(res.data))
            .catch(err => console.error('Error cargando unidades funcionales:', err));
    }, [barrio?.id, administracionId]);

    const [configuracionesTipoGasto, setConfiguracionesTipoGasto] = useState([]);

    useEffect(() => {
        if (!administracionId || !barrio?.id) return;
        axios.get(`${HOST_API}api/configuracionTipoGasto/GetConfiguracionTipoGasto?administracionId=${administracionId}&barrioId=${barrio.id}`)
            .then(res => setConfiguracionesTipoGasto(res.data))
            .catch(err => console.error('Error cargando configuraciones de tipo de gasto:', err));
    }, [administracionId, barrio?.id]);

    const gastoLabel = (g) => [g.tipoGasto, g.modoCalculo, g.modoDistribucion].filter(Boolean).join(' · ');

    const location = useLocation();
    const [selectedDate, setSelectedDate] = useState(location.state?.selectedDate ?? new Date());

    const [openDialog, setOpenDialog] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

     
    const HOST_API = process.env.REACT_APP_URL;
    const urlGastosDelete = `${HOST_API}api/gastoBarrio/deleteGasto`;
    const urlSaveGastos = `${HOST_API}api/gastoBarrio/saveGasto`;
    const urlProveedores = `${HOST_API}api/proveedores/getProveedores?proveedorId=0`;
    const excludedCampos = ["proveedorId", "fechaAlta", "usuario"];

    const [cargos, setCargos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [gruposGasto, setGruposGasto] = useState([]);



    const handleNuevoGasto = () => {
      setEditingId(null);          // modo alta
      setFormData({});             // limpiÃ¡s el form
      setVisible(true);            // abrÃ­s el dialog
    };

    const handleDateChange = (value) => {
      setSelectedDate(value);
    };

    const handleEditarGasto = async (rowData) => {
      setEditingId(rowData.gastoUFId);
      setLoadingBackdrop(true);
      try {
        const response = await axios.get(`${HOST_API}api/gastosUF/GetGastoUFById`, {
          params: { gastoUFId: rowData.gastoUFId, administracionId, barrioId: barrio.id },
        });
        setFormData({
          ...initialFormData,
          ...response.data,
          periodo: response.data.periodo ? new Date(response.data.periodo) : null,
        });
        setVisible(true);
      } catch (err) {
        console.error(err);
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar los datos para editar', life: 3000 });
      } finally {
        setLoadingBackdrop(false);
      }
    };

    const [loadingBackdrop, setLoadingBackdrop] = useState(false);


  const formatDate = (date) => {
    if (!date) return "";

    const year  = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day   = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      barrioId: barrio.id,
      administracionId,
      periodo: formData.periodo || selectedDate,
    };

    try {

      await axios.post(`${HOST_API}api/gastosUF/SaveGastoUF`, payload);
      setVisible(false);   // cerrar dialog
      fetchExpensas();       // refrescar la grilla (la que armamos antes con useCallback)

    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = (liqGastoId) => {
    confirmDialog({
      message: '¿Estás seguro de eliminar este gasto?',
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Eliminar',
      rejectLabel: 'Cancelar',
      accept: () => deleteGasto(liqGastoId),
    });
  };

  const deleteGasto = async (liqGastoId) => {
    try {
      await axios.delete(`${urlGastosDelete}/${liqGastoId}`);

      setCargos((prev) => prev.filter((g) => g.liqGastoId !== liqGastoId));
    } catch (error) {
      console.error("Error eliminando gasto:", error);
    }
  };

  const handleModify = (liqGastoId) => {
    confirmDialog({
      message: '¿Estás seguro de eliminar este gasto?',
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Eliminar',
      rejectLabel: 'Cancelar',
      accept: () => deleteGasto(liqGastoId),
    });
  };


const getOpcionesCombo = (tablaCombo) => {
    switch (tablaCombo) {
      case "Proveedores":
        return proveedores;
      case "EstadosPago":
        return [
          { id: 2, descripcion: "Pendiente" },
          { id: 1, descripcion: "Pagado" },
        ];
      case "GrupoGastoBase":
        return [
          {id:3, descripcion: "Impuestos y Servicios"},
          {id:7, descripcion: "Seguridad Privada"},
          {id:8, descripcion: "Seguros"},
          {id:4, descripcion: "Mantenimiento y Abonos"},
          {id:5, descripcion: "Reparaciones"},
          {id:2, descripcion: "Gastos Bancarios, Legales, Administrativos y Registrales"},
          {id:1, descripcion: "Aportes y Cargas Sociales"},
          {id:6, descripcion: "Remuneraciones"}
        ];
      default:
        return [];
    }
  };

  const grupos = {
      3: "Impuestos y Servicios",
      7: "Seguridad Privada",
      8: "Seguros",
      4: "Mantenimiento y Abonos",
      5: "Reparaciones",
      2: "Gastos Bancarios, Legales, Administrativos y Registrales",
      1: "Aportes y Cargas Sociales",
      6: "Remuneraciones"
  };

   const fetchExpensas = useCallback(async () => {
      if (!selectedDate || !barrio?.id) return;

      setLoadingBackdrop(true);
      try {
        const fecha = formatDate(selectedDate);

        //const urlGastos = `${HOST_API}api/cargosPeriodoUF/GetCargosPeriodoUF`;
        const urlGastos = `${HOST_API}api/gastosUF/GetGastosUF?barrioId=${barrio.id}&periodo=${fecha}&administracionId=${administracionId}`;

        

        const response = await axios.get(urlGastos);
        
        console.log(response.data);
        setCargos(response.data);


      } catch (err) {
        setError(err.message || "Error al obtener gastos");
      } finally {
        setLoading(false);
        setLoadingBackdrop(false);
      }
    }, [selectedDate, barrio?.id, administracionId]);

    useEffect(() => {
      fetchExpensas();
    }, [fetchExpensas]);


    const [proveedores, setProveedores] = useState([]);
    const [estadosPago, setEstadosPago] = useState([]);
    const [barrios, setBarrios] = useState([]);
    //const [grupos, setGrupos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);

    const menu1 = useRef(null);
    const toolbarItems = [
        {
            label: 'Save',
            icon: 'pi pi-check'
        },
        {
            label: 'Update',
            icon: 'pi pi-upload'
        },
        {
            label: 'Delete',
            icon: 'pi pi-trash'
        },
        {
            label: 'Home Page',
            icon: 'pi pi-home'
        }
    ];


    const flattenRow = (row) => {
      const flat = {};
      for (const [key, value] of Object.entries(row)) {
        if (typeof value === "object" && value !== null && !key.endsWith("_type")) {
          for (const [nestedKey, nestedValue] of Object.entries(value)) {
            flat[nestedKey] = nestedValue;
            flat[`${nestedKey}_type`] = row[`${key}_type`] ?? "currency";
          }
        } else {
          flat[key] = value;
        }
      }
      return flat;
    };

    const cargosFlat = useMemo(() => cargos?.map(flattenRow) ?? [], [cargos]);    

    const camelToHeader = (key) => {
      return key
        .replace(/([A-Z])/g, " $1")       // inserta espacio antes de cada mayÃºscula
        .replace(/^./, (str) => str.toUpperCase()) // capitaliza la primera letra
        .trim();
    };

    const handleChangeCargo = (campo, valor) => {
      
      setFormData((prev) => ({
        ...prev,
        [campo]: valor,
      }));
    
    };

    // FunciÃ³n para formatear el valor segÃºn el tipo
    const formatValue = (value, type) => {
      if (value === null || value === undefined) return "";

      switch (type) {
        case "date":
          return new Date(value).toLocaleDateString("es-AR");
        case "currency":
          return typeof value === "number"
            ? value.toLocaleString("es-AR", { style: "currency", currency: "ARS" })
            : value;
        default:
          // Si por alguna razÃ³n llega un objeto, lo serializa en lugar de romper
          return typeof value === "object" ? JSON.stringify(value) : value;
      }
    };

    // Derivar columnas dinÃ¡micas a partir del primer row
    const columns = useMemo(() => {
      if (!cargosFlat?.length) return [];

      const firstRow = cargosFlat[0];

      return Object.keys(firstRow)
        .filter((key) => !key.endsWith("_type")) // excluir las keys de tipo
        .map((field) => ({
          field,
          type: firstRow[`${field}_type`] ?? "text",
          header: camelToHeader(field), // podÃ©s mapear a un label mÃ¡s amigable si querÃ©s
        }));
    }, [cargos]);

    return (
      <>
        <h4>Asignación de Gastos por {t.UnidadFuncional}</h4>
        <br />

        <ConfirmDialog />
        <Toast ref={toast} />
        <LoadingOverlay visible={loadingBackdrop} />

        <div className="flex align-items-center gap-3">

    {/* Botones uno al lado del otro */}
        <div className="flex gap-2">
              <Button
                  label="Nuevo Gasto"
                  icon="pi pi-shopping-cart"
                  onClick={() => setVisible(true)}
              />
          </div>

          {/* Calendar al lado */}
          <Calendar
              value={selectedDate}
              view="month"
              dateFormat="mm/yy"
              onChange={(e) => handleDateChange(e.value)}
              showIcon
              className="p-inputtext-sm"
          />
      </div>

      <br></br>

        <div className="grid">
                <Dialog
                    header={`Gasto ${t.UnidadFuncional}`}
                    visible={visible}
                    style={{ width: "70vw" }}
                    breakpoints={{ "960px": "100vw" }} // responsive en mobile
                    modal
                    onHide={() => setVisible(false)}
                >
                  <form className="p-fluid grid" onSubmit={handleSubmit}>
                    <div className="col-12 md:col-12">
                      <div className="col-12 flex flex-wrap gap-3 mt-3">

                        <div className="w-full md:w-4">
                          <label>{t.UnidadFuncional}</label>
                          <Dropdown
                            value={formData.unidadFuncionalId || null}
                            options={unidadesFuncionales}
                            optionLabel="unidadFuncional"
                            optionValue="unidadFuncionalId"
                            onChange={(e) => handleChangeCargo("unidadFuncionalId", e.value)}
                            placeholder={`Seleccionar ${t.UF}`}
                            className="p-inputtext-sm w-full"
                            filter
                          />
                        </div>

                        <div className="w-full md:w-4">
                          <label>Gasto</label>
                          <Dropdown
                            value={formData.configuractionTipoGastoId || null}
                            options={configuracionesTipoGasto}
                            optionLabel="tipoGasto"
                            optionValue="configuractionTipoGastoId"
                            itemTemplate={gastoLabel}
                            valueTemplate={(option) => option ? gastoLabel(option) : 'Seleccionar...'}
                            onChange={(e) => handleChangeCargo("configuractionTipoGastoId", e.value)}
                            placeholder="Seleccionar..."
                            className="p-inputtext-sm w-full"
                            filter
                            filterBy="tipoGasto,modoCalculo,modoDistribucion"
                          />
                        </div>

                        <div className="w-full md:w-4">
                          <label>Importe</label>
                          <InputText
                            type="number"
                            step="0.01"
                            value={formData.importe || ""}
                            onChange={(e) => handleChangeCargo("importe", e.target.value)}
                            className="p-inputtext-sm w-full"
                          />
                        </div>

                        <div className="w-full md:w-4">
                          <label>Periodo</label>
                          <Calendar
                            value={formData.periodo || selectedDate}
                            view="month"
                            dateFormat="mm/yy"
                            onChange={(e) => handleChangeCargo("periodo", e.value)}
                            showIcon
                            className="p-inputtext-sm"
                          />
                        </div>

                        <div className="w-full md:w-4 flex align-items-center gap-2 mt-4">
                          <Checkbox
                            inputId="aplica"
                            checked={!!formData.aplica}
                            onChange={(e) => handleChangeCargo("aplica", e.checked)}
                          />
                          <label htmlFor="aplica">Aplica</label>
                        </div>

                        <div className="w-full">
                          <label>Observaciones</label>
                          <InputText
                            type="text"
                            value={formData.observaciones || ""}
                            onChange={(e) => handleChangeCargo("observaciones", e.target.value)}
                            className="p-inputtext-sm w-full"
                          />
                        </div>

                        <div className="col-12 mt-3">
                          <Button label="Guardar" icon="pi pi-save" type="submit" />
                        </div>

                      </div>
                  </div>
                </form>
    
                </Dialog>
          

            <div className="col-12 md:col-12"> 

              <DataTable
                value={cargosFlat}
                paginator
                rows={10}
                showGridlines
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                responsiveLayout="scroll"
                emptyMessage="No hay cargos cargadas"
                className="p-datatable-gridlines bg-white"
              >
                {columns.map(({ field, header, type }) => (
                  <Column
                    key={field}
                    field={field}
                    header={header}
                    sortable
                    body={(row) => formatValue(row[field], type)}
                  />
                ))}
                <Column
                    header="Acciones"
                    style={{ width: '8rem' }}
                    body={(row) => (
                        <div className="flex gap-2 justify-content-center">
                            <Button icon="pi pi-pencil" rounded text severity="warning" onClick={() => handleEditarGasto(row)} tooltip="Editar" />
                            <Button icon="pi pi-trash" rounded className="btn-delete" onClick={() => handleDelete(row.gastoUFId)} tooltip="Eliminar" />
                        </div>
                    )}
                />
              </DataTable>

                
            </div>
            
        </div>
        </>
    );
};

export default GastoUnidadFuncional;
